import { ErrorMessage } from '@hookform/error-message';
import { Button, Card, CardTitle, Label, Separator } from '@repo/shadcn';
import { FormProvider } from 'react-hook-form';
import { PiPlusCircleDuotone } from 'react-icons/pi';

import { DynamicControl } from '@/shared/dynamic-control.tsx';

import BtnLoader from '../../../../ui/loader/btn-loader';
import { createBrandFields } from '../../products/utils/product-inputs';
import { useEditBrand } from './edit-brand.hook';

export const EditBrand = () => {
    const { handleSubmit, form, isLoading } = useEditBrand();

    return (
        <Card className="border-none shadow-none">
            <CardTitle className="mb-2 text-[18px]"> Edit Brand</CardTitle>
            <Separator />
            <form onSubmit={handleSubmit}>
                <FormProvider {...form}>
                    <div className=" mt-5 grid grid-cols-1 gap-5">
                        {createBrandFields.map((d, i) => (
                            <div key={i} className={`mt-3  ${d.className}`}>
                                <div className=" item-center mb-2 flex h-fit justify-between">
                                    <Label className="h-fit ">{d.label}</Label>
                                    {d.actionBtn && (
                                        <Label className="flex cursor-pointer items-center  gap-1 text-primary hover:underline">
                                            <PiPlusCircleDuotone
                                                size={16}
                                                className="-mt-1"
                                            />{' '}
                                            {d.actionBtnLabel}
                                        </Label>
                                    )}
                                </div>
                                <DynamicControl {...d} />
                                <ErrorMessage
                                    name={d.fieldName}
                                    render={({ message }) => (
                                        <p className="mt-1 text-sm text-red-600">
                                            {message}
                                        </p>
                                    )}
                                />
                            </div>
                        ))}
                    </div>
                </FormProvider>
                {/* <FormButton type="submit">save</FormButton> */}
                <Button className="mt-5">
                    {isLoading ? <BtnLoader /> : 'Save'}
                </Button>
            </form>
        </Card>
    );
};

EditBrand.displayName = 'EditBrand';
